var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 21H3M19.88 7L11 15.83L7 17L8.17 13L17.05 4.12C17.4256 3.71344 17.9471 3.47248 18.5002 3.44999C19.0532 3.42749 19.5926 3.62529 20 4C20.1932 4.20274 20.3437 4.44225 20.4426 4.70429C20.5414 4.96633 20.5866 5.24557 20.5754 5.52541C20.5642 5.80525 20.4968 6.07999 20.3774 6.3333C20.2579 6.58662 20.0888 6.81334 19.88 7V7Z",
    stroke: "currentColor",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.6f8a5ca56d446bbaffb29915c746b3c6.svg";
export { ForwardRef as ReactComponent };